<template>
  <div class="box">
    <div class="title" style="padding-top: 17px;margin-bottom: 25px;">专利</div>
    <div class="banner-image" id="patentChart" style="width:100%;height: 183px;"></div>
  </div>
</template>

<script>
export default {
  name: 'patent',
  created () {
    this.drawChart();
  },
  methods: {
    drawChart () {
      const _self = this;
      _self.post('/dataapi/open/nqi/fruit/bigScreenPatentCount').then(res => {
        _self.typeList = res.result;
        _self.chart = echarts.init(document.getElementById('patentChart'));
        let xAxis = [];
        let value = [];
        for (let item of _self.typeList) {
          xAxis.push(item.fruit_type);
          value.push({
            value: item.rs
          });
        }
        _self.chart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            }
          },
          grid: {
            top: '15%',
            right: '3%',
            left: '12%',
            bottom: '22%'
          },
          xAxis: [{
            type: 'category',
            data: xAxis,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            },
            axisLabel: {
              margin: 10,
              color: '#e2e9ff',
              textStyle: {
                fontSize: 10
              },
              interval: 0,
              rotate: 13
            }
          }],
          yAxis: [{
            axisLabel: {
              formatter: '{value}',
              color: '#e2e9ff'
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            }
          }],
          series: [{
            type: 'bar',
            data: value,
            barWidth: '13px',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(24,31,68,1)',
              borderRadius: 30
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00CCD2' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#00A2FF' // 100% 处的颜色
                }], false),
                barBorderRadius: [30, 30, 30, 30],
                shadowColor: 'rgba(0,160,221,1)',
                shadowBlur: 4
              }
            }
          }]
        });
      });
    }
  }
}
</script>

<style scoped>
.box{
  background-image: url('../assets/images/contentBg-min.png');
  background-size: 100% 100%;
  width: 100%;
  height: 248px;
}
.title{
  width: 36px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #00FFF4;
  line-height: 25px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/patent.vue